export default __webpack_public_path__ + "static/media/forgot-password-step-3.58b39de9.webp";